<template>
    <div class="row mt-4">
        <div class="col-xl-10 offset-xl-1">
            <card>
                <card-header>
                    <h2>
                        WebChat Details
                    </h2>
                </card-header>

                <card-body>
                    <div class="alert alert-danger" role="alert" v-if="errors">
                        Please, check errors!
                    </div>

                    <input-text
                        label="Webchat Name"
                        :form="form"
                        v-model="form.name"
                        field="name"
                    />
                    <div v-if="webchatgroups">
                        <div class="form-group">
                            <label class="pr-3">Use Multi-group WebChat</label>
                            <toggle-button
                                class="mb-0"
                                :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                                :sync="true"
                                :labels="{ checked: 'On', unchecked: 'Off' }"
                                :width="45"
                                :height="20"
                                :speed="200"
                                v-model="form.use_groups"
                                @change="showWebChatGroupOptions"
                            />
                        </div>
                    </div>
                    <div>
                        <div class="form-group">
                            <label class="pr-3">Send Click Url <small>*receive in messenger what url chat was received on.</small></label>
                            <toggle-button
                                class="mb-0"
                                :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                                :sync="true"
                                :labels="{ checked: 'On', unchecked: 'Off' }"
                                :width="45"
                                :height="20"
                                :speed="200"
                                v-model="form.click_url"
                                @change="showWebChatGroupOptions"
                            />
                        </div>
                    </div>
                    <div class="form-group" v-if="!form.use_groups">
                        <label>Location(s)</label>
                        <multiselect
                            id="location_id"
                            :options="allLocations"
                            :multiple="true"
                            placeholder="Select location(s)"
                            track-by="id"
                            label="name"
                            v-model="form.locations"
                            @input="checkIfIsSelectAll"
                            :class="{'is-invalid': form.errors.has('locations')}"
                        />

                        <span class="invalid-feedback" v-if="form.errors.has('locations')">
                            {{ form.errors.get('locations') }}
                        </span>
                    </div>

                    <h3 class="mb-3">
                        Customizations
                    </h3>

                    <fieldset class="border p-3 mb-3 rounded">
                        <legend class="px-2 w-auto customization__legend">
                            Button
                        </legend>

                        <div class="form-group">
                            <label for="bgColor">Background Button Color</label>
                            <colorpicker
                                :color="form.bg_launcher_color"
                                v-model="form.bg_launcher_color"
                            />
                        </div>

                        <div class="row">
                            <div class="col-6 form-group">
                                <input-text
                                    label="Bottom Distance"
                                    :form="form"
                                    v-model="form.bottom_distance"
                                    field="bottom_distance"
                                />
                            </div>

                            <div class="col-6 form-group">
                                <input-text
                                    label="Distance from right"
                                    :form="form"
                                    v-model="form.right_distance"
                                    field="right_distance"
                                />
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="border p-3 mb-3 rounded">
                        <legend class="px-2 w-auto customization__legend">
                            Images
                        </legend>

                        <div class="row">
                            <div class="col-3 form-group">
                                <label>Icon button</label>
                                <div class="row">
                                    <div class="col-4 form-group">
                                        <div class="block__custom__logo text-center selectable_icon">
                                            <div class="my-2 mx-auto launcher launcher__custom__icon"
                                                 :style="{ backgroundColor: form.bg_launcher_color }">
                                                <div class="launcher__iconContainer">
                                                    <div class="launcher__icon">
                                                        <img v-if="form.custom_icon && form.custom_icon !== 'alt'"
                                                             :src="icon_url"
                                                             width="40px" height="40px" class="rounded-circle">

                                                        <img v-if="form.custom_icon && form.custom_icon === 'alt'"
                                                             :src="`${base_url}/widget/images/launcher-icon-alt.png`"
                                                             width="40px" height="40px">

                                                        <img v-if="!form.custom_icon"
                                                             :src="`${base_url}/widget/images/launcher-icon-default.png`"
                                                             width="40px" height="40px">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <file-select
                                            label="avatar-logo"
                                            event="avatar-logo"
                                            @avatar-logo="handleAvatarLogoCustom"
                                            :width="40"
                                            :height="40"
                                        >
                                        <span class="text-muted custom__avatar__text pl-2">
                                            Change
                                        </span>
                                        </file-select>
                                    </div>
                                    <div class="col-4 form-group">
                                        <div v-if="icon_url !== `${base_url}/widget/images/launcher-icon-alt.png`">
                                            <div class="block__custom__logo text-center selectable_icon"
                                                 @click="updateIconUrl('alt')">
                                                <div class="my-2 mx-auto launcher launcher__custom__icon"
                                                     :style="{ backgroundColor: form.bg_launcher_color }">
                                                    <div class="launcher__iconContainer">
                                                        <div class="launcher__icon">
                                                            <img
                                                                :src="`${base_url}/widget/images/launcher-icon-alt.png`"
                                                                width="40px" height="40px">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div class="block__custom__logo text-center selectable_icon"
                                                 @click="updateIconUrl('default')">
                                                <div class="my-2 mx-auto launcher launcher__custom__icon"
                                                     :style="{ backgroundColor: form.bg_launcher_color }">
                                                    <div class="launcher__iconContainer">
                                                        <div class="launcher__icon">
                                                            <img
                                                                :src="`${base_url}/widget/images/launcher-icon-default.png`"
                                                                width="40px" height="40px">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4 form-group">
                                        <div v-if="form.custom_icon && form.custom_icon !== 'alt'">
                                            <div class="block__custom__logo text-center selectable_icon"
                                                 @click="updateIconUrl('default')">
                                                <div class="my-2 mx-auto launcher launcher__custom__icon"
                                                     :style="{ backgroundColor: form.bg_launcher_color }">
                                                    <div class="launcher__iconContainer">
                                                        <div class="launcher__icon">
                                                            <img
                                                                :src="`${base_url}/widget/images/launcher-icon-default.png`"
                                                                width="40px" height="40px">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3 form-group">

                            </div>
                            <div class="col-6 form-group">
                                <label>Avatar</label>
                                <div class="d-flex justify-content-center flex-wrap">
                                    <div class="position-relative webchat__avatarInput"
                                         v-for="(avatar, index) in avatars" :key="index">
                                        <input type="radio" name="avatar" :id="avatar"
                                               :value="avatar"
                                               v-model="form.avatar">
                                        <label :for="avatar" class="m-2 cursor-pointer">
                                            <img class="rounded-circle border"
                                                 :src="`${base_url}/widget/images/avatar/${avatar}`" width="56">
                                        </label>
                                    </div>
                                    <file-select
                                        label="avatar"
                                        event="avatar"
                                        @avatar="handleAvatarCustom"
                                        :width="128"
                                        :height="128"
                                    >
                                        <template v-if="!form.custom_avatar">
                                            <div class="m-2 position-relative webchat__avatarInput cursor-pointer">
                                                <div class="rounded-circle border custom__avatar m-auto">
                                                    <img class="p-3"
                                                         :src="`${base_url}/img/upload.svg`" width="56">
                                                </div>
                                                <span class="text-muted custom__avatar__text">
                                                    Upload photo
                                                </span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="position-relative webchat__avatarInput">
                                                <input type="radio" name="avatar" id="custom-avatar"
                                                       :value="form.avatar_url"
                                                       v-model="form.avatar">
                                                <label for="custom-avatar" class="m-2 cursor-pointer">
                                                    <img class="rounded-circle border"
                                                         :src="avatar_url" width="56">
                                                </label>
                                                <file-select
                                                    class="text-center"
                                                    label="avatar"
                                                    event="avatar"
                                                    @avatar="handleAvatarCustom"
                                                    :width="128"
                                                    :height="128">
                                                    <span class="text-muted custom__avatar__text">
                                                        Change
                                                    </span>
                                                </file-select>
                                            </div>
                                        </template>
                                    </file-select>
                                    <div class="position-relative webchat__avatarInput">
                                        <input type="radio" name="avatar" id="no-avatar" v-model="form.avatar">
                                        <label for="no-avatar" class="m-2 cursor-pointer">
                                            <img class="rounded-circle"
                                                 :src="`${base_url}/widget/images/avatar/no-image.svg`" width="56">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="border p-3 mb-3 rounded">
                        <legend class="px-2 w-auto customization__legend">
                            Modal Welcome
                        </legend>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="card card-default mb-0 preview__modal__welcome">
                                    <div class="card-body tw-relative swell-webchat">
                                        <!-- Launcher -->
                                        <div
                                            class="swell-chat-w-16 swell-chat-h-16 swell-chat-rounded-full swell-chat-flex swell-chat-items-center swell-chat-justify-center swell-chat-cursor-pointer tw-absolute"
                                            :style="{ right: '20px', bottom: '20px', backgroundColor: form.bg_launcher_color }">
                                            <img alt="swell-avatar"
                                                 v-if="form.custom_icon && form.custom_icon !== 'alt'"
                                                 :src="icon_url"
                                                 width="40px" height="40px" class="rounded-circle"/>

                                            <img alt="swell-avatar"
                                                 v-if="form.custom_icon && form.custom_icon === 'alt'"
                                                 :src="`${base_url}/widget/images/launcher-icon-alt.png`"
                                                 width="40px" height="40px"/>

                                            <img alt="swell-avatar" v-if="!form.custom_icon"
                                                 :src="`${base_url}/widget/images/launcher-icon-default.png`"
                                                 width="40px" height="40px"/>

                                        </div>

                                        <!-- Welcome Card -->
                                        <div class="swell-chat-flex swell-chat-flex-col tw-absolute tw-max-w-xs"
                                             style="right: -11px;bottom: 88px;">
                                            <div
                                                class="swell-chat-bg-gray-400 swell-chat-cursor-pointer swell-chat-mb-1 swell-chat-px-2 swell-chat-py-px swell-chat-rounded-full swell-chat-self-end swell-chat-text-gray-600 swell-chat-text-sm swell-chat-tracking-wider tw-mr-5">
                                                close
                                            </div>

                                            <div
                                                class="swell-chat-bg-white swell-chat-cursor-pointer swell-chat-flex swell-chat-mb-3 swell-chat-p-4 swell-chat-relative swell-chat-rounded-lg swell-chat-shadow-lg swell-chat-space-x-3 tw-mr-5">
                                                <template v-if="form.avatar">
                                                    <img alt="welcome-chat-avatar" v-if="activeCustomAvatar"
                                                         :src="avatar_url"
                                                         class="swell-chat-rounded-full"
                                                         style="width: 50px;height: 50px;">

                                                    <img alt="welcome-chat-avatar" v-else
                                                         :src="`${base_url}/widget/images/avatar/${form.avatar}`"
                                                         class="swell-chat-rounded-full"
                                                         style="width: 50px; height: 50px;">
                                                </template>

                                                <span class="swell-chat-text-gray-600 swell-chat-text-sm">
                                                    {{ form.welcome_text }}
                                                </span>

                                                <div
                                                    class="swell-chat-bg-white swell-chat-w-6 swell-chat-h-6 swell-chat-absolute swell-chat-transform swell-chat-rotate-45 swell-chat-rounded swell-chat-bottom-0 swell-chat-right-5 swell-chat--mb-1">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 mt-3 mt-md-0">
                                <div>
                                    <label>Message</label>
                                    <textarea class="form-control"
                                              :class="{'is-invalid': form.errors.has('welcome_text')}"
                                              v-model="form.welcome_text"></textarea>
                                    <span class="invalid-feedback" v-if="form.errors.has('welcome_text')">
                                        {{ form.errors.get('welcome_text') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="border p-3 mb-4 rounded" v-if="form.use_groups">
                        <legend id="group-form-customizations" class="px-2 w-auto customization__legend">
                            Group Customizations
                        </legend>

                        <div class="row">
                            <div class="col-lg-6 mt-3 mt-lg-0">
                                <div class="form-group">
                                    <label>Select Group(s)</label>
                                    <multiselect
                                        id="webChatGroup_id"
                                        :options="webchatgroups"
                                        :multiple="true"
                                        placeholder="Select Group(s)"
                                        track-by="id"
                                        label="name"
                                        v-model="form.webchat_groups"
                                        :close-on-select="false"
                                        :class="{'is-invalid': form.errors.has('webchat_group_ids')}"
                                        @input="updateSelectedGroups"
                                    />

                                    <span class="invalid-feedback" v-if="form.errors.has('webchat_group_ids')">
                                        {{ form.errors.get('webchat_group_ids') }}
                                    </span>
                                </div>
                                <div class="form-group">
                                    <label for="">
                                        Background Color
                                    </label>
                                    <colorpicker :color="form.bg_header_group_color"
                                                 v-model="form.bg_header_group_color"/>
                                </div>

                                <div class="form-group">
                                    <input-text
                                        label="Header Title"
                                        :form="form"
                                        v-model="form.group_title_header"
                                        field="group_title_header"
                                    />
                                </div>

                                <div class="form-group">
                                    <input-text
                                        label="Header Description"
                                        :form="form"
                                        v-model="form.group_text_header"
                                        field="group_text_header"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="card card-default mb-0">
                                    <div class="card-body tw-flex tw-flex-col tw-items-end swell-webchat">
                                        <!-- GROUP FORM -->
                                        <div
                                            class="swell-chat-overflow-hidden swell-chat-rounded-lg swell-chat-w-full swell-chat-max-w-sm sm:swell-chat-mr-8 swell-chat-mb-3 tw-shadow-md">
                                            <div class="swell-chat-text-white swell-chat-p-3 swell-chat-space-y-2"
                                                 :style="{ backgroundColor: form.bg_header_group_color }">
                                                <div class="swell-chat-flex swell-chat-space-x-2">
                                                    <img v-if="form.avatar"
                                                         :src="form.avatar === form.custom_avatar ? form.avatar_url : `${base_url}/widget/images/avatar/${form.avatar}`"
                                                         class="swell-chat-w-9 swell-chat-rounded-full"
                                                         alt="group-avatar">
                                                    <div class="swell-chat-text-2xl">{{ form.group_title_header }}</div>
                                                </div>
                                                <div class="swell-chat-text-sm">{{ form.group_text_header }}</div>
                                            </div>

                                            <div
                                                class="swell-chat-bg-gray-50 swell-chat-py-1 swell-chat-px-2 swell-chat-text-sm swell-chat-text-gray-700">
                                                <div class="swell-chat-relative swell-chat-mt-1 ">
                                                    <div
                                                        class="swell-chat-left-0 swell-chat-pl-3 swell-chat-absolute swell-chat-inset-y-0 swell-chat-flex swell-chat-items-center swell-chat-pointer-events-none">
                                                        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                             class="swell-chat-w-5 swell-chat-h-5 swell-chat-text-gray-400">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                  stroke-width="2"
                                                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                                                        </svg>
                                                    </div>
                                                    <input id="search" @input="groupSearchFilter($event.target.value)"
                                                           type="text" v-model="groupSearchFilterValue"
                                                           class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-pl-10 swell-chat-border-none swell-chat-text-sm sm:swell-chat-leading-5 focus:swell-chat-shadow-none swell-chat-bg-gray-50"
                                                           placeholder="Search"/>
                                                </div>
                                            </div>

                                            <div
                                                class="swell-chat-bg-white swell-chat-px-5 swell-chat-py-4 swell-chat-pb-20 swell-chat-space-y-4" style="overflow-y: auto;max-height: 464px;">

                                                <div v-if="failedGroupFilter"
                                                     class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-px-5 swell-chat-py-2">
                                                    <div class="swell-chat-tracking-wide">* No match found!</div>
                                                </div>

                                                <div v-for="group in filteredSelectedGroups">
                                                    <div
                                                        class="swell-chat-bg-gray-100 swell-chat-text-gray-500 swell-chat-text-sm swell-chat-rounded-lg swell-chat-px-5 swell-chat-py-2 swell-chat-cursor-pointer swell-chat-border-2 swell-chat-border-transparent hover:swell-chat-border-gray-500">
                                                        <div class="swell-chat-font-medium">{{ group.name }}</div>
                                                        <div class="swell-chat-text-gray-400 swell-chat-tracking-wide">
                                                            {{ group.description }}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div
                                                class="swell-chat-bg-gray-200 swell-chat-flex swell-chat-justify-center swell-chat-text-xs swell-chat-py-2 swell-chat-items-center swell-chat-space-x-1">
                                                <img alt="swell-logo" :src="`${base_url}/widget/images/power-icon.svg`"
                                                     width="20px" height="20px"/>
                                                <span>We run on Swell</span>
                                            </div>
                                        </div>

                                        <!-- Launcher -->
                                        <div
                                            class="swell-chat-w-16 swell-chat-h-16 swell-chat-rounded-full swell-chat-flex swell-chat-items-center swell-chat-justify-center swell-chat-cursor-pointer"
                                            :style="{ right: '20px', bottom: '20px', backgroundColor: '#e73e51' }">
                                            <img alt="close-icon"
                                                 :src="`${base_url}/widget/images/launcher-icon-close.svg`"
                                                 class="swell-chat-w-4"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="border p-3 mb-4 rounded">
                        <legend class="px-2 w-auto customization__legend">
                            Modal Form Message
                        </legend>

                        <div class="row">
                            <div class="col-lg-6">
                                <div class="card card-default mb-0">
                                    <div class="card-body tw-flex tw-flex-col tw-items-end swell-webchat">
                                        <!-- FORM -->
                                        <div
                                            class="swell-chat-max-w-sm swell-chat-mb-3 swell-chat-overflow-hidden swell-chat-rounded-lg swell-chat-w-full tw-shadow-md">
                                            <div
                                                class="swell-chat-text-white swell-chat-p-3 swell-chat-flex swell-chat-flex-col"
                                                v-if="form.use_groups"
                                                :style="{ backgroundColor: form.bg_header_color }">
                                                <div class="swell-chat-flex swell-chat-space-x-2">
                                                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                         class="swell-chat-w-8 swell-chat-text-white swell-chat-cursor-pointer">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                              stroke-width="2"
                                                              d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"/>
                                                    </svg>
                                                    <div class="swell-chat-text-2xl">{{ form.title_header }}</div>
                                                </div>
                                                <div class="swell-chat-text-sm">{{ form.text_header }}</div>
                                            </div>

                                            <div v-else
                                                 class="swell-chat-text-white swell-chat-p-3 swell-chat-flex swell-chat-flex-col swell-chat-items-center"
                                                 :style="{ backgroundColor: form.bg_header_color }">

                                                <img alt="swell-header-avatar" v-if="form.avatar"
                                                     :src="form.avatar === form.custom_avatar ? form.custom_avatar : `${base_url}/widget/images/avatar/${form.avatar}`"
                                                     class="swell-chat-rounded-full"
                                                     style="width: 50px;">

                                                <div class="swell-chat-text-2xl">{{ form.title_header }}</div>
                                                <div class="swell-chat-text-sm">{{ form.text_header }}</div>
                                            </div>

                                            <div
                                                class="swell-chat-bg-gray-50 swell-chat-py-4 swell-chat-px-5 swell-chat-text-sm swell-chat-text-gray-700">
                                                {{ form.text_invitation }}
                                            </div>

                                            <div
                                                class="swell-chat-bg-white swell-chat-px-5 swell-chat-py-4 swell-chat-pb-20 ">
                                                <div class="swell-chat-space-y-4">
                                                    <div>
                                                        <label for="name"
                                                               class="swell-chat-block swell-chat-text-sm swell-chat-leading-5 swell-chat-text-gray-600">Name</label>
                                                        <div
                                                            class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-shadow-sm">
                                                            <input id="name" disabled="disabled"
                                                                   class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                                                   placeholder="Your name"/>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <label for="phone_number"
                                                               class="swell-chat-block swell-chat-text-sm swell-chat-leading-5 swell-chat-text-gray-600">
                                                            Phone Number
                                                        </label>
                                                        <div
                                                            class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-shadow-sm">
                                                            <input id="phone_number" type="tel" disabled="disabled"
                                                                   class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                                                   placeholder="(000) 000-0000"/>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <label for="message"
                                                               class="swell-chat-block swell-chat-text-sm swell-chat-leading-5 swell-chat-text-gray-600">Message</label>
                                                        <div
                                                            class="swell-chat-mt-1 swell-chat-relative swell-chat-rounded-md swell-chat-shadow-sm">
                                                            <textarea id="message" disabled="disabled"
                                                                      class="swell-chat-form-input swell-chat-block swell-chat-w-full swell-chat-sm:text-sm swell-chat-sm:leading-5"
                                                                      placeholder="Write your message here..."
                                                                      rows="3"></textarea>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="swell-chat-flex swell-chat-flex-col swell-chat-items-center swell-chat-space-y-2 swell-chat-pt-5">
                                                        <button
                                                            class="swell-chat-items-center swell-chat-text-white swell-chat-flex swell-chat-rounded-full swell-chat-px-5 swell-chat-py-2 swell-chat-opacity-80 hover:swell-chat-opacity-100 swell-chat-text-2xl"
                                                            :style="{ backgroundColor: form.bg_header_color }">
                                                            <span class="swell-chat-mr-2">Text me</span>
                                                            <svg aria-hidden="true" focusable="false" data-prefix="fas"
                                                                 data-icon="paper-plane"
                                                                 role="img"
                                                                 xmlns="http://www.w3.org/2000/svg"
                                                                 viewBox="0 0 512 512"
                                                                 class="swell-chat-w-6">
                                                                <path data-v-655bfd02="" fill="currentColor" d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2
                                                                            43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176
                                                                            407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2
                                                                            6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"></path>
                                                            </svg>
                                                        </button>
                                                        <div class="swell-chat-text-gray-400 swell-chat-text-xs">
                                                            Message and data rates may apply.
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div
                                                class="swell-chat-bg-gray-200 swell-chat-flex swell-chat-justify-center swell-chat-text-xs swell-chat-py-2 swell-chat-items-center swell-chat-space-x-1">
                                                <img alt="swell-logo" :src="`${base_url}/widget/images/power-icon.svg`"
                                                     width="20px" height="20px"/>
                                                <span>We run on Swell</span>
                                            </div>
                                        </div>

                                        <!-- Launcher -->
                                        <div
                                            class="swell-chat-w-16 swell-chat-h-16 swell-chat-rounded-full swell-chat-flex swell-chat-items-center swell-chat-justify-center swell-chat-cursor-pointer"
                                            :style="{ right: '20px', bottom: '20px', backgroundColor: '#e73e51' }">
                                            <img alt="close-icon"
                                                 :src="`${base_url}/widget/images/launcher-icon-close.svg`"
                                                 class="swell-chat-w-4"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3 mt-lg-0">
                                <div class="form-group">
                                    <label for="color-picker">
                                        Background Header Color
                                    </label>
                                    <colorpicker :color="form.bg_header_color" v-model="form.bg_header_color"
                                                 id="color-picker"/>
                                </div>

                                <div class="form-group">
                                    <input-text
                                        label="Title Header"
                                        :form="form"
                                        v-model="form.title_header"
                                        field="title_header"
                                        :disabled="form.use_groups"
                                    />
                                </div>

                                <div class="form-group">
                                    <input-text
                                        label="Text Header"
                                        :form="form"
                                        v-model="form.text_header"
                                        field="text_header"
                                        :disabled="form.use_groups"
                                    />
                                </div>

                                <div class="form-group">
                                    <label for="Text Invitation">Text Invitation</label>
                                    <textarea class="form-control"
                                              :class="{'is-invalid': form.errors.has('text_invitation')}"
                                              v-model="form.text_invitation"></textarea>
                                    <span class="invalid-feedback" v-if="form.errors.has('text_invitation')">
                                        {{ form.errors.get('text_invitation') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </fieldset>

                    <fieldset class="border p-3 mb-4 rounded">
                        <legend id="modal-form-message" class="px-2 w-auto customization__legend">
                            Automated Response
                        </legend>
                        <div class="d-flex justify-between">
                            <label>Hours Of Operation</label>
                            <small v-if="!timezone" class="ml-auto float-right text-muted" style="padding-top: 4px">
                                Server Time:
                                <server-time
                                    class="ml-1"
                                    format="hh:mm:ss a"
                                />
                            </small>
                            <small v-else class="ml-auto float-right text-muted" style="padding-top: 4px">
                                Your Time:
                                <server-time
                                    class="ml-1"
                                    format="hh:mm:ss a"
                                    :timezone="timezone"
                                />
                            </small>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group"
                                     :class="{'is-invalid': form.errors.has('business_operation_start_time')}">
                                    <vue-ctk-date-time-picker
                                        v-model="form.business_operation_start_time"
                                        label="Start Time"
                                        :no-label="true"
                                        format="hh:mm a"
                                        formatted="hh:mm a"
                                        color="#0374D7"
                                        :minute-interval="1"
                                        :only-time="true"
                                    />
                                    <p v-if="form.errors.has('business_operation_start_time')" class="invalid-feedback">
                                        {{ form.errors.get('business_operation_start_time') }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group"
                                     :class="{'is-invalid': form.errors.has('business_operation_end_time')}">
                                    <vue-ctk-date-time-picker
                                        v-model="form.business_operation_end_time"
                                        label="End Time"
                                        :no-label="true"
                                        format="hh:mm a"
                                        formatted="hh:mm a"
                                        color="#0374D7"
                                        :minute-interval="1"
                                        :only-time="true"
                                    />
                                    <p v-if="form.errors.has('business_operation_end_time')" class="invalid-feedback">
                                        {{ form.errors.get('business_operation_end_time') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="pr-3 pl-2">Use Business Hours Automated Response</label>
                                    <toggle-button
                                        class="mb-0"
                                        :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                                        :sync="true"
                                        :labels="{ checked: 'On', unchecked: 'Off' }"
                                        :width="45"
                                        :height="20"
                                        :speed="200"
                                        v-model="form.use_business_hours_automated_response"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Text Invitation">Business Hours Automated Response</label>
                                    <textarea class="form-control"
                                              :class="{'is-invalid': form.errors.has('business_hours_msg')}"
                                              v-model="form.business_hours_msg"></textarea>
                                    <span class="invalid-feedback" v-if="form.errors.has('business_hours_msg')">
                                            {{ form.errors.get('business_hours_msg') }}
                                        </span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="pr-3">Use After Hours Automated Response</label>
                                    <toggle-button
                                        class="mb-0"
                                        :color="{ checked: '#0074d9', unchecked: '#dc3545' }"
                                        :sync="true"
                                        :labels="{ checked: 'On', unchecked: 'Off' }"
                                        :width="45"
                                        :height="20"
                                        :speed="200"
                                        v-model="form.use_after_hours_automated_response"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Text Invitation">After Hours Automated Response</label>
                                    <textarea class="form-control"
                                              :class="{'is-invalid': form.errors.has('after_hours_msg')}"
                                              v-model="form.after_hours_msg"></textarea>
                                    <span class="invalid-feedback" v-if="form.errors.has('after_hours_msg')">
                                            {{ form.errors.get('after_hours_msg') }}
                                        </span>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    <div class="text-right">
                        <button class="btn btn-primary" @click="save">
                            Save customizations
                        </button>
                    </div>
                </card-body>
            </card>
        </div>
    </div>
</template>

<script>
    import FileSelect           from './FileSelect.vue'
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

    export default {
        props: {
            customizations: {
                type    : Object,
                required: true
            },

            locations: {
                type    : Array,
                required: true
            },

            webchatgroups: {
                required: true
            }
        },

        data() {
            return {
                timezone              : null,
                selectedGroups        : [],
                form                  : new Form(this.setupForm(this.customizations)),
                allLocations          : this.locations,
                base_url              : window.location.origin,
                avatars               : [
                    'jay-lee.jpg',
                    'quan-le.jpg',
                    'ronny-sison.jpg',
                    'benjamin-parker.jpg',
                    'eduardo-dutra.jpg',
                    'jurica-koletic.jpg',
                ],
                icon_url              : this.customizations.icon_url || null,
                avatar_url            : this.customizations.avatar_url || null,
                filteredSelectedGroups: [],
                groupSearchFilterValue: null,
                failedGroupFilter     : false
            }
        },

        components: {
            FileSelect,
            VueCtkDateTimePicker,
        },

        created() {
            this.fetchTimezone();
            this.setAllToLocations();
            this.filteredSelectedGroups = this.form.webchat_groups;
        },

        computed: {
            errors() {
                return Object.keys(this.form.errors.errors).length;
            },

            activeCustomAvatar() {
                return this.form.custom_avatar && this.form.custom_avatar === this.form.avatar;
            },
        },

        methods: {
            fetchTimezone() {
                return this.$http.get(route('api.teams.current-team-timezone')).then(({data}) => {
                    this.timezone = data;
                });
            },
            setupForm(data = {}) {
                this.selectedGroups = data.webchat_group_ids;
                return {
                    id                                   : data.id || null,
                    name                                 : data.name,
                    locations                            : data.locations,
                    title_header                         : data.title_header,
                    text_header                          : data.text_header,
                    text_invitation                      : data.text_invitation,
                    bg_launcher_color                    : data.bg_launcher_color,
                    bg_header_color                      : data.bg_header_color,
                    bottom_distance                      : data.bottom_distance,
                    right_distance                       : data.right_distance,
                    welcome_text                         : data.welcome_text,
                    avatar                               : data.avatar,
                    custom_avatar                        : data.custom_avatar,
                    custom_icon                          : data.custom_icon,
                    bg_header_group_color                : data.bg_header_group_color || data.bg_launcher_color,
                    group_title_header                   : data.group_title_header || 'Select a Group',
                    group_text_header                    : data.group_text_header || 'Please select the correct group and we\'ll put you in touch!',
                    webchat_group_ids                    : data.webchat_group_ids || [],
                    webchat_groups                       : data.webchat_groups || [],
                    use_groups                           : data.use_groups,
                    business_hours_msg                   : data.business_hours_msg,
                    after_hours_msg                      : data.after_hours_msg,
                    use_after_hours_automated_response   : data.use_after_hours_automated_response,
                    use_business_hours_automated_response: data.use_business_hours_automated_response,
                    business_operation_end_time          : data.business_operation_end_time,
                    business_operation_start_time        : data.business_operation_start_time,
                    click_url                            : data.click_url || false,
                };
            },

            setAllToLocations() {
                this.allLocations.unshift({id: 0, name: 'Select All'});
            },

            checkIfIsSelectAll(options) {
                if (options.filter(f => f.id === 0).length > 0) {
                    this.form.locations = this.locations.filter(f => f.id !== 0);
                }
            },

            handleAvatarLogoCustom(value, url) {
                this.form.custom_icon = value;
                this.icon_url         = url;
            },

            handleAvatarCustom(value, url) {
                this.form.avatar        = value;
                this.form.custom_avatar = value;
                this.avatar_url         = url;
            },

            save() {
                if (this.form.use_groups) {
                    if (this.selectedGroups.length) {
                        this.form.webchat_group_ids = this.selectedGroups;
                    }
                    this.form.use_groups = true;
                } else {
                    delete this.form.use_groups;
                }
                const request = this.form.id ? this.update() : this.create();

                request.then((response) => {
                    window.location.replace(this.$laroute.route('webchat.index'));
                    return false;
                }).catch((response) => {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 1000);
                });
            },

            async create() {
                return await this.form.post(this.$laroute.route('webchat.store'));
            },

            async update() {
                return await this.form.put(this.$laroute.route('webchat.update', {webchat: this.form.id}));
            },

            showWebChatGroupOptions() {
                if (this.form.use_groups) {
                    this.form.text_header  = "Selected Group Description";
                    this.form.title_header = "Selected Group Name";
                } else {
                    this.form.text_header  = this.customizations.text_header;
                    this.form.title_header = this.customizations.title_header;
                }
            },

            groupSearchFilter(searchString) {
                this.filteredSelectedGroups = [];
                if (searchString === null || searchString.match(/^ *$/) !== null) {
                    this.groupSearchFilterValue = null;
                    this.filteredSelectedGroups = this.form.webchat_groups;
                    this.failedGroupFilter      = false;
                    return;
                }
                this.filteredSelectedGroups = [];
                if (!this.form.webchat_groups.length) {
                    return;
                }

                this.form.webchat_groups.forEach((group) => {
                    searchString = searchString.toLowerCase();
                    if (group.name.toLowerCase().includes(searchString) || group.description.toLowerCase().includes(searchString)) {
                        this.filteredSelectedGroups.push(group);
                    }
                });

                this.failedGroupFilter = !this.filteredSelectedGroups.length;
            },

            updateSelectedGroups() {
                this.selectedGroups = [];
                this.form.webchat_groups.forEach((group) => {
                    this.selectedGroups.push(group.id);
                });
                this.filteredSelectedGroups = this.form.webchat_groups;
                this.groupSearchFilterValue = null;
            },

            updateIconUrl(type = 'default') {
                if (type === 'alt') {
                    this.form.custom_icon = 'alt';
                    this.icon_url         = this.base_url + '/widget/images/launcher-icon-alt.png';
                } else {
                    this.form.custom_icon = null;
                    this.icon_url         = this.customizations.icon_url || null;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../widget/chat";

    .selectable_icon {
        &:hover {
            cursor: pointer;
        }
    }

    .customization__legend {
        font-size: 1.2rem;
    }

    .custom__avatar {
        width: 56px;
    }

    .custom__avatar__text {
        font-size: .7rem;
    }

    .avatar__options {
        outline: none;
    }

    .block__custom__logo {
        max-width: 80px;
    }

    .launcher {

        &:not(.launcher__custom__icon) {
            position: absolute;
        }

        width: 60px;
        height: 60px;
        border-radius: 50%;
        z-index: 10;
        box-shadow: 0 10px 20px rgba(0, 0, 0, .2);
    }

    .launcher__iconContainer {
        position: relative;
        width: 100%;
        height: 100%;

        svg {
            vertical-align: initial;
        }
    }

    .launcher__icon {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1, 1);
    }

    .launcher__iconClose {
        width: 25px;
        height: 25px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(.8, .8) rotate(-180deg);
    }

    .webchat__avatarInput {
        label {
            padding: 2px;
        }

        [type="radio"] {
            position: absolute;
            left: -9999px;

            &:checked {

                + label {
                    box-shadow: 0 0 0 2px #0374d7;
                    border-radius: 50%;
                }
            }
        }
    }

    .preview__modal__welcome {
        height: 280px;
    }

    .modal__welcome {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin: 15px;
        width: 100%;
        max-width: 317px;
        position: absolute;
        bottom: 80px;
        right: 4px;
    }

    .modal__welcome__closeButton {
        background-color: #e3e4e5;
        border-radius: 99px;
        border: none;
        color: #000000;
        cursor: pointer;
        font-size: 12px;
        padding: 5px 15px;
        margin-right: 3px;
        margin-bottom: 4px;
    }

    .modal__welcome__message {
        display: flex;
        border: 1px solid #e8e9eb;
        box-shadow: 0 8px 20px 0 rgba(0, 0, 0, .24);
        background: #fff;
        border-radius: 13px;
        max-width: 290px;
        padding: 24px;
        width: 100%;
        position: relative;

        &::after {
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            bottom: -6px;
            right: 18px;
            background: #fff;
            border-radius: 4px;
            transform: rotate(45deg);
        }
    }

    .modal__welcome__avatarWrapper {
        padding-right: 12px;
    }

    .preview__modal__widgetLauncherShown {
        height: 880px;
    }

    .modal__widgetLauncherShown {
        position: absolute;
        right: 30px;
        bottom: 100px;
        width: 340px;
        border-radius: 8px;
        box-shadow: rgba(0, 0, 0, .16) 0 5px 40px;
    }

    .form__messenger__frame {
        background-color: #fff;
        border-radius: 8px;
    }

    .form__messenger__frame__header {
        padding: 15px 10px;
        border-radius: 8px 8px 0 0;
    }

    .form__messenger__frame__header__content,
    .frame__header__content__title {
        height: 100%;
        width: 100%;
        color: #fff;
        font-size: 14px;
    }

    .frame__header__content__title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 24px;
    }

    .form__messenger__frame__formContainer {
        display: flex;
        flex-direction: column;
        min-height: 400px;
    }

    .group__messenger__frame__container {
        display: fixed;
        flex-direction: column;
    }

    .group__content__container {
        display: flex;
        flex-direction: column;
        min-height: 450px;
        max-height: 465px;
    }

    .group__messenger__frame__scrollContainer {
        display: flex;
        flex-direction: column;
        min-height: 450px;
        max-height: 465px;
        overflow: auto;
    }

    .group__messenger__frame__groupContainer {
        position: relative;
        margin: 5px 24px 5px 24px;
        color: rgba(0, 0, 0, .5);
        font-size: 13px;
        font-weight: 400;
        min-height: 50px;
        background-color: #e4e9f0;
        border-radius: 16px 16px 16px 16px;
        padding: 8px 24px;

        p {
            margin: 0 0 0 5px;
            color: #999999;
            font-size: 14px;
            font-weight: normal;

            b {
                font-size: 16px;
                color: #5c5c5c;
            }

        }
    }

    .searchBar {
        position: relative;
        margin: 10px 24px 10px 24px;
        border: 2px solid #a0a0a0;
        border-radius: 5px;

        i {
            color: #a0a0a0
        }

        input {
            resize: none;
            background: 0 0;
            border: 0;
            color: #333;
            font-size: 16px;
            height: 30px;
            outline: 0;
            position: relative;
            width: 80%;
            z-index: 1;
            max-height: 76px;
        }
    }

    .searchBarAlt {
        position: relative;
        margin: 1rem 20px 5px 20px;

        i {
            color: rgba(0, 0, 0, .5);
            font-size: 13px;
            left: 0;
            line-height: 16px;
            pointer-events: none;
            position: absolute;
            top: .5em;
            transition: .2s ease;
            white-space: nowrap;
            z-index: 2;
        }

        label {
            color: rgba(0, 0, 0, .5);
            font-size: 13px;
            font-weight: 400;
            line-height: 16px;
            left: 20px;
            pointer-events: none;
            position: absolute;
            top: .5em;
            transition: .2s ease;
            white-space: nowrap;
            z-index: 2;
        }

        input,
        textarea {
            resize: none;
            background: 0 0;
            border: 0;
            color: #333;
            font-size: 16px;
            height: 30px;
            outline: 0;
            position: relative;
            width: 100%;
            z-index: 1;
            max-height: 76px;

            &:valid,
            &:focus {
                ~ label {
                    -webkit-transform: translate(-10%, -128%) scale(.8);
                    transform: translate(-10%, -128%) scale(.8);
                    color: #4c76e0;
                }

                ~ i {
                    -webkit-transform: translate(-10%, -128%) scale(.8);
                    transform: translate(-10%, -128%) scale(.8);
                    color: #4c76e0;
                }
            }

            &:focus {
                ~ .textInput__bar {
                    &:after,
                    &:before {
                        width: 50%;
                    }
                }
            }
        }
    }

    .form__messenger__backArrow {
        color: #fff;
        margin: 0 10px 0 0;

        a {
            color: inherit;
        }
    }

    .form__messenger__frame__textInvitation {
        width: 84%;
        display: flex;
        align-items: center;
        color: #5c5c5c;
        font-size: 14px;
        line-height: 1.5;
        margin: 16px 0 16px 16px;
    }

    .frame__textInvitation__avatar {
        margin-right: 16px;
    }

    .frame__textInvitation__message {
        background-color: #e4e9f0;
        border-radius: 16px 16px 16px 3px;
        padding: 15px 24px;
    }

    .form__messenger__frame__formContent {
        width: 84%;
        display: flex;
        flex-direction: column;
        align-self: flex-end;
        background-color: #f8f8f8;
        border-radius: 16px 16px 3px 16px;
        margin: 0 16px 0 0;
        padding: 16px 24px 40px 24px;
    }

    .textInput {
        position: relative;
        margin: 1rem 0;

        label {
            color: rgba(0, 0, 0, .5);
            font-size: 13px;
            font-weight: 400;
            left: 0;
            line-height: 16px;
            pointer-events: none;
            position: absolute;
            top: .5em;
            transition: .2s ease;
            white-space: nowrap;
            z-index: 2;
        }

        input,
        textarea {
            resize: none;
            background: 0 0;
            border: 0;
            color: #333;
            font-size: 16px;
            height: 30px;
            outline: 0;
            position: relative;
            width: 100%;
            z-index: 1;
            max-height: 76px;

            &:focus {
                ~ label {
                    transform: translate(-10%, -128%) scale(.8);
                    color: #4c76e0;
                }

                ~ .textInput__bar {
                    &:after,
                    &:before {
                        width: 50%;
                    }
                }
            }
        }
    }

    .textInput__textarea {
        min-height: initial;
        margin-top: .35em;
    }

    .textInput__bar {
        background-color: #ccc;
        bottom: 0;
        height: 1px;
        left: 0;
        position: absolute;
        width: 100%;
        z-index: 10;

        &:after,
        &:before {
            background-color: #4c76e0;
            content: '';
            height: 2px;
            position: absolute;
            transition: .2s ease;
            width: 0;
        }

        &:before {
            left: 50%;
        }

        &:after {
            right: 50%;
        }
    }

    .form__messenger__frame__formButton {
        padding-bottom: 12px;
    }

    .formButton__terms {
        margin: 16px auto;
        text-align: center;
        color: #adadad;
        font-size: 10px;
        max-width: 25em;
        line-height: 1.6;
    }

    .formButton__button {
        text-align: center;
        margin-bottom: 16px;
    }

    .sendButton {
        font-weight: 400;
        position: relative;
        cursor: pointer;
        margin: 0 auto;
        padding: 12px 20px;
        font-size: 16px;
        border-radius: 42px;
        color: #fff;

        &:focus {
            outline: none;
        }
    }

    .sendButtonTextIcon {
        display: inline-block;
        width: 20px;
        height: 20px;
        vertical-align: middle;
        margin-left: 5px;
    }

    .power__container {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f8f8f8;
        border-radius: 0 0 8px 8px;
    }

    .power__Link {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #6f7881;
        font-size: 11px;

        &:hover {
            text-decoration: none;
            color: #6f7881;
        }
    }

    .is-invalid {
        .invalid-feedback {
            display: block;
        }
    }
</style>
